"use client";

import React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function TwoColumnStickyImage() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="twocolumnstickyimage" className="bg-white py-8 md:py-24 overflow-hidden relative">
  {/* 背景裝飾大字 */}
  <div className="absolute top-1/4 right-0 text-[20rem] font-serif font-bold text-primary/[0.02] select-none pointer-events-none leading-none -translate-y-1/2">
    Hent
  </div>

  <div className="container mx-auto px-8 lg:px-16 max-w-[1400px] relative z-10">
    {/* 關鍵：父層使用 items-stretch 確保左右等高 */}
    <div className="flex flex-col lg:flex-row items-stretch relative gap-16 lg:gap-0">
      
    {/* 左側：固定圖片區塊 */}
<div className="w-full lg:w-[480px] flex-none lg:sticky lg:top-32 z-10 mx-auto lg:mx-0 lg:self-stretch"> 
  {/* 關鍵點 1: lg:self-stretch 確保在電腦版時，這個容器會拉長到跟右側內容一樣高 */}
  
  <div className="relative group h-[300px] lg:h-full"> 
    {/* 關鍵點 2: lg:h-full 讓內容填滿父層撐開的高度 */}
    
    <div className="relative overflow-hidden rounded-sm bg-muted shadow-[30px_30px_80px_rgba(0,0,0,0.06)] border border-border/40 h-full">
      <img src="https://hent.services/wp-content/uploads/2026/05/3500K-lighting-HD4006.jpg" alt="Hent's 質感木地板生活空間" className="object-cover w-full h-full transition-transform duration-[2.5s] group-hover:scale-110" />
      
   
    </div>
  </div>
</div>

      {/* 右側：文字內容區 */}
      <div ref={ref} className={cn("w-full flex-1 lg:pl-40 flex flex-col justify-between transition-all duration-[1.2s] ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
        {/* 內容包裹容器，確保第一層到第四層決定整體高度 */}
        <div className="flex flex-col h-full">
          
          <div className="flex flex-col items-start w-fit">
            {/* 第一層：品牌主標題與色塊 */}
            <div className="relative mb-6 -mt-4 w-full">
              <div className="absolute left-0 bottom-1 w-full h-2 bg-[#D9C5B2]/80 -z-10" />
              <h2 className="text-2xl md:text-4xl font-hk-regular text-foreground tracking-tight leading-tight whitespace-nowrap">
                Hent's 亨特超耐磨木地板
              </h2>
            </div>

            {/* 第二層：水平分割線與年份 */}
            <div className="flex items-center justify-between w-full mb-16">
              <div className="h-[1px] bg-border w-24" />
              <span className="text-primary/40 font-sans tracking-[0.3em] text-[10px] uppercase whitespace-nowrap pl-8">
                / SINCE 2026
              </span>
            </div>
          </div>

          {/* 第三層：核心訴求與簡介 */}
          <div className="mb-4 space-y-6 max-w-[650px]">
            <h3 className="text-2xl md:text-4xl text-foreground tracking-wide font-tc-extralight">
              讓理想地板輕鬆實現
            </h3>
            <p className="text-foreground/70 text-lg leading-relaxed tracking-wide font-hk-light">
              專業高效率的服務，從丈量、選材到施工，<br className="hidden md:block" />
              每一個細節都用心把關，讓您省時、省力又安心。
            </p>
          </div>

          {/* 第四層：圓形圖示功能區 */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-y-12 gap-x-13 max-w-[650px] pt-8 mx-auto md:mx-0 mt-auto">
            {[{
                label: "預約門市參觀",
                icon: "https://hent.services/wp-content/uploads/2026/05/Reservation.png",
                delay: "delay-100"
              }, {
                label: "到府幫你量",
                icon: "https://hent.services/wp-content/uploads/2026/05/Measurement.png",
                delay: "delay-200"
              }, {
                label: "材料施工一起包",
                icon: "https://hent.services/wp-content/uploads/2026/05/All-in-One-Service.png",
                delay: "delay-300"
              }, {
                label: "安排快速完成",
                icon: "https://hent.services/wp-content/uploads/2026/05/Installation.png",
                delay: "delay-400"
              }].map((item, idx) => <div key={idx} className={cn("group flex flex-col items-center md:items-start transition-all duration-700", item.delay, isVisible ? "opacity-100 scale-100" : "opacity-0 scale-90")}>
                <div className="size-20 md:size-24 rounded-full bg-[#f0e6e1] border border-[#e5d8d2] flex items-center justify-center overflow-hidden shadow-sm transition-all duration-500 group-hover:shadow-md group-hover:bg-[#eaddd7] mb-4">
                  <img src={item.icon} alt={item.label} className="w-[52%] h-[52%] object-contain grayscale opacity-70 transition-all duration-500 group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-110" />
                </div>
                <p className="text-[12px] md:text-sm text-foreground/80 tracking-tighter text-center md:text-left font-tc-semibold max-w-[120px] md:max-w-none">
                  {item.label}
                </p>
              </div>)}
          </div>

        </div>
      </div>

    </div>
  </div>
</section>;
}